export default __webpack_public_path__ + "static/media/cute-cat-emoji.b2cfbc4d.svg";